import { BaseServices } from 'src/app/kuba/kuba.services';
import { Component, OnInit } from '@angular/core';
import { editorContactTabs } from './editorcontact-tabs';

@Component({
    templateUrl: 'editorcontacts.component.html',
  standalone: false
})
export class EditorContactsComponent implements OnInit {
    tabs: { linkText: string; translationKey: string }[] = [];
    constructor() {}

    ngOnInit() {
        this.tabs = editorContactTabs(BaseServices.roleId);
    }
}
